import { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { Button } from "../../../components";
import { FormInput, FormTextArea } from "../../../components/forms";
import {
    HeadOfficeMasterAccountDesignationsSelect,
    HeadOfficeMasterAccountSelect,
    HeadOfficeWrapperProductsSelect,
    HeadOfficeWrappersSelect
} from "../../../components/forms/selects";
import ThemedModal from "../../../components/utilities/ThemedModal";

const EditCustodianAccountMatchModal = ({ data, onHide, updateFn }) => {
    const show = useMemo(() => data != null, [data]);
    const [tempMatch, setTempMatch] = useState(data);

    const {
        mapId,
        custodianCode,
        platformAccountId,
        masterAccountId,
        masterAccountName,
        designationId,
        wrapperId,
        productId,
        notes,
        providerReference
    } = tempMatch || {};

    const handleMatchChange = (properties) => {
        setTempMatch(prev => ({
            ...prev,
            ...properties
        }));
    };

    const onSubmit = () => {
        toast.promise(updateFn(mapId, tempMatch), {
            loading: "Updating mapping...",
            error: (err) => err?.data ?? "Unable to update mapping.",
            success: () => {
                onHide();
                return "Mapping updated!";
            }
        })
    };

    useEffect(() => {
        data && setTempMatch(data);
    }, [data]);

    return (
        <Modal dialogClassName="min-w-1/3" centered backdrop="static" show={show} onHide={onHide}>
            <ThemedModal.Header closeButton>
                <Modal.Title>Edit Match</Modal.Title>
            </ThemedModal.Header>
            <Modal.Body>
                <div className="row mb-3">
                    <div className="col">
                        <FormInput
                            label="Custodian"
                            readOnly
                            value={custodianCode}
                        />
                    </div>
                    <div className="col">
                        <FormInput
                            label="Platform Account"
                            value={platformAccountId}
                            readOnly
                        />
                    </div>
                    <div className="col">
                        <FormInput
                            label="Provider Reference"
                            value={providerReference}
                            onChange={(e) => handleMatchChange({ providerReference: e.target.value })}
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <HeadOfficeMasterAccountSelect
                            label="Master Account"
                            valueObject={{ label: masterAccountName, value: masterAccountId }}
                            onChange={({ label, value }) => handleMatchChange({ masterAccountId: value, masterAccountName: label, designationId: null })}
                        />
                    </div>
                    <div className="col">
                        <HeadOfficeMasterAccountDesignationsSelect
                            label="Designation"
                            defaultValue={designationId}
                            masterAccountId={masterAccountId}
                            onChange={({ value }) => handleMatchChange({ designationId: value })}
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <HeadOfficeWrappersSelect
                            label="Wrapper"
                            defaultValue={wrapperId}
                            onChange={({ value }) => handleMatchChange({ wrapperId: value, productId: null })}
                        />
                    </div>
                    <div className="col">
                        <HeadOfficeWrapperProductsSelect
                            label="Product"
                            defaultValue={productId}
                            wrapperId={wrapperId}
                            onChange={({ value }) => handleMatchChange({ productId: value })}
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <FormTextArea
                        label="Notes"
                        value={notes}
                        minRows={4}
                        onChange={e => handleMatchChange({ notes: e.target.value })}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={onHide}>Cancel</Button>
                <Button variant="success" onClick={onSubmit}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditCustodianAccountMatchModal;